module.exports = __webpack_public_path__ + "img/title.28d3a1d0.svg";